import { render, staticRenderFns } from "./Sendpush.vue?vue&type=template&id=c888998a"
import script from "./Sendpush.vue?vue&type=script&lang=js"
export * from "./Sendpush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports